import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

import {mediaQueryBreakpointSM} from "../Utils/Utils.js";

const WPCoreGallery = (blockElem) => {

	let slidesPerView = parseInt(blockElem.dataset.slidesPerView);
	slidesPerView = ( slidesPerView >= 3 ? slidesPerView - .95 : slidesPerView ); // Subtract a bit so the slides won't fill the entire viewport, but instead will be "cut off" in the sides

	// We don't want to display the figcaption for the entire gallery.
	// This figcaption also mess up the loop, so we remove it completely
	const galleryFigcaption = blockElem.querySelector('.blocks-gallery-caption');
	if(galleryFigcaption) {
		galleryFigcaption.parentNode.removeChild(galleryFigcaption);
	}

	const swiperControls = blockElem.querySelector('.swiper-controls');

	const swiper = new Swiper(blockElem, {
		modules: [Navigation, Pagination],
		loop: true,
		slidesPerView : 1,

		pagination: {
			el: '.swiper-pagination',
		},
		navigation: {
			nextEl: swiperControls.querySelector('.swiper-button-next'),
			prevEl: swiperControls.querySelector('.swiper-button-prev'),
		},

		breakpoints: {
			[mediaQueryBreakpointSM]: {
				slidesPerView : slidesPerView,
				loopedSlides: Math.floor(slidesPerView),
				centeredSlides: true,
				spaceBetween: 30, //slidesPerView === 1 ? 30 : 30,
			}
		}
	});

	const renderSwiperControls = () => {
		const activeSlide = swiper.slides[swiper.activeIndex];
		swiperControls.style.width = `${activeSlide.offsetWidth/10}rem`;
		swiperControls.style.height = `${activeSlide.offsetHeight/10}rem`;
	}

	window.addEventListener('resize', () => {
		renderSwiperControls();
		setTimeout(renderSwiperControls, 50);
	});

	renderSwiperControls();
};

export default WPCoreGallery;